import { render, staticRenderFns } from "./spec-features-item.vue?vue&type=template&id=80d587e8&scoped=true&"
import script from "./spec-features-item.vue?vue&type=script&lang=js&"
export * from "./spec-features-item.vue?vue&type=script&lang=js&"
import style0 from "./spec-features-item.vue?vue&type=style&index=0&id=80d587e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d587e8",
  null
  
)

export default component.exports